import React, { useState, useEffect } from 'react';
import styles from "./SignFooter.module.css"
import { FaFacebookF, FaTwitter, FaLinkedin, FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";
import { db } from '../../../firebase-config';
import { doc, getDoc } from 'firebase/firestore';

function SignFooter() {
    const [miscellaneousContent, setMiscellaneousContent] = useState({
        affiliatedRituals: '',
        copyright: '',
        termsOfUse: ''
    });
    const [isLoading, setIsLoading] = useState(true);

    // Fetch miscellaneous content from Firestore
    const fetchMiscellaneous = async () => {
        try {
            setIsLoading(true);
            const docRef = doc(db, 'siteContent', 'miscellaneous');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setMiscellaneousContent({
                    affiliatedRituals: data.affiliatedRituals || '',
                    copyright: data.copyright || '',
                    termsOfUse: data.termsOfUse || ''
                });
            } else {
                setMiscellaneousContent({
                    affiliatedRituals: '',
                    copyright: '',
                    termsOfUse: ''
                });
            }
        } catch (error) {
            console.error('Error fetching miscellaneous content:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMiscellaneous();
    }, []);

    return (
        <div
            className={styles.footerSection}
        >
            <div className={styles.footer}>
                <div className={styles.footerBoxContainer}>
                    <div className={styles.footerBox}>
                        <h3>Affiliated Ritual</h3>
                        <div className={styles.footerBanner}></div>
                        {isLoading ? (
                            <p>Loading content...</p>
                        ) : miscellaneousContent.affiliatedRituals ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.affiliatedRituals }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>
                    <div className={styles.footerBox}>
                        <h3>Useful Links</h3>
                        <div className={styles.footerBanner}></div>
                        <a href="/">Home </a>
                        <a href="/teammember?action=register">Become a partner</a>
                        <a href="/trainer?action=register">Become a trainer</a>
                    </div>

                    <div className={styles.footerBox}>
                        <h3>Our Company</h3>
                        <div className={styles.footerBanner}></div>
                        <a href="/contact-us">Contact Us</a>
                        <a href="/disclaimer">Disclaimer</a>
                        <a href="/tnc">Terms and Conditions</a>
                        <a href="/refund-policy">Refund Policy</a>
                    </div>

                    <div className={styles.footerBox}>
                        <h3>Get In Touch</h3>
                        <div className={styles.footerBanner}></div>
                        <p>Like, Share, Follow and Subscribe.
                            If you love Affiliate Ritual</p>

                        <div className={styles.footerMedia}>
                            <FaFacebookF />
                            <FaInstagram />
                            <FaTwitter />
                            <FaWhatsapp />
                            <FaLinkedin />
                            <FaYoutube />
                        </div>

                    </div>
                </div>

                <div className={styles.footerCredit}>
                    <div>
                        {isLoading ? (
                            <p>Loading...</p>
                        ) : miscellaneousContent.copyright ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.copyright }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>

                    <div>
                        {isLoading ? (
                            <p>Loading...</p>
                        ) : miscellaneousContent.termsOfUse ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.termsOfUse }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignFooter;
